import styled from "styled-components";
import LeftBackground from "panel/src/assets/images/bg-hero-banner.png";

export default styled.img.attrs({ src: LeftBackground })`
  max-height: 100vh;
`;
